import { getShippingTracking, ShippingTrackingResult, ShippingTrackingApi } from "@dana/Services/DanaOrderRelatedService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess
} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";
import { DanaShippingTrackingActions } from "@dana/Store/Data/OrderHistory/Reducers/GetShippingTrackingReducer";

type RequestShippingTracking = {
    orderNumber?: string;   
} & HasOnSuccess<any> & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<RequestShippingTracking, ShippingTrackingApi, ShippingTrackingResult, DispatchProp<DanaShippingTrackingActions>>;

export const SetLoadingOn: HandlerType = props => {
    props.dispatch?.({
        type: "DanaShippingTracking/IsLoading",
        isLoading: true,
    });
}

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getShippingTracking({
        orderNumber: props.parameter.orderNumber,       
    });
};

export const PopulateFacetResult: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch?.({
            type: "DanaShippingTracking/PopulateResult",
            data: props.apiResult,
        } as any);
    }
}

export const chain = [SetLoadingOn, SendDataToApi, PopulateFacetResult];

const GetShippingTrackingData = createHandlerChainRunner(chain, "GetShippingTrackingData");
export default GetShippingTrackingData;